import OrderAccordian, { OrderAccordianProps } from './OrderAccordian';

export type { OrderAccordianProps };
export default OrderAccordian;
